<template>
  <div class="row">
    <div class="col">
      <label>Paciente</label>
      <div class="input-group input-focus">
        <a-auto-complete style="width: 200px" v-model:value="formConsult.nome" @search="handleSearchPaciente" class="form-control">
          <template v-slot:dataSource>
            <a-select-option v-for="item in pacientesSearch" :key="item.id" :value="item.nome" @click="onSelectPac(item)">
              {{ item.nome }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </div>
    </div>
    <div class="col-3">
      <label>CPF</label>
      <div class="input-group input-focus">
        <a-auto-complete style="width: 200px" v-model:value="formConsult.cpf" v-mask="'###.###.###-##'" @search="handleSearchPacienteCpf" class="form-control">
          <template v-slot:dataSource>
            <a-select-option v-for="item in pacientesCpfSearch" :key="item.id" :value="item.nome" @click="onSelectPac(item)">
              {{ item.nome }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </div>
    </div>
    <div class="col">
      <label>Unidade</label>
      <select class="form-select" ref="catUnidade" v-model="formConsult.unidadeAtendimento">
        <option v-for="item in unidadeAtendimentos" :key="item.descricao" :value="item.descricao">
          {{ item.descricao }}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Data inicial</label>
      <input v-model="formConsult.dataInicio" type="date" class="ant-input" />
      <label>Data final</label>
      <input v-model="formConsult.dataFim" type="date" class="ant-input" />
    </div>
    <div class="col-sm-1" style="width: 6%; margin-left: -22px">
      <div class="input-group-prepend" style="margin-top: 23px">
        <span class="input-group-text bg-white" @click="pesquisar(false)"><i class="fa fa-search"></i></span>
      </div>
    </div>
    <div class="col-sm-1" style="width: 6%; margin-left: -22px">
      <div class="input-group-prepend" style="margin-top: 23px">
        <span class="input-group-text bg-white" @click="limpar()"><i class="fa fa-eraser"></i></span>
      </div>
    </div>
  </div>

  <a-table :dataSource="todosAtendimentos" :columns="columns">
    <template #paciente="{ record }">
      <span class="paciente">{{ record.paciente.nome }}</span>
    </template>
    <template #tipoAgendamento="{ record }">
      <div class="col col-icon">
        <div v-if="record.tipoAgendamento === 'VIRTUAL'">
          <i class="fa-solid fa-desktop icon-atendimento"></i>
        </div>
        <div v-if="record.tipoAgendamento === 'PRESENCIAL'">
          <i class="fa-solid fa-people-carry-box icon-atendimento"></i>
        </div>
      </div>
    </template>
    <template #registrarAtendimento="{ record }">
      <i class="fa-solid fa-circle-plus icon-atendimento" v-if="!record.possuiAtendimento" @click="registrarAtendimento(record)"></i>

      <i class="fa-solid fa-file-pen icon-atendimento" v-if="record.possuiAtendimento" @click="registrarAtendimento(record)"></i>
    </template>
  </a-table>
</template>

<script>
import moment from 'moment';
import { getPaciente } from '@/components/service/pacienteService';
import { validarCpf } from '@/utils/servicos-utils';
import { getUnidadeAtendimento } from '@/config/servicos-utils';
import { consultarAgendamento, getByIdAgendamento } from '@/components/service/agendamento-medico';
import { createRegistroAtendimento, getByIdAgendamentoMedico } from '@/components/service/registroAtendimentoService';

export default {
  name: 'PageRegistrarAtendimento',
  props: {
    idProf: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      pacientesSearch: [],
      pacientesCpfSearch: [],
      unidadeAtendimentos: [],
      todosAtendimentos: [],

      formConsult: {
        idProfissional: null,
        unidadeAtendimento: null,
        idPaciente: null,
        cpf: null,
        dataInicio: null,
        dataFim: null,
      },
      columns: [
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: {
            customRender: 'data',
          },
        },
        {
          title: 'Horário',
          dataIndex: 'horario',
          key: 'horario',
          slots: {
            customRender: 'horario',
          },
        },
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: {
            customRender: 'paciente',
          },
        },
        {
          title: 'Modo da Consulta',
          dataIndex: 'tipoAgendamento',
          key: 'tipoAgendamento',
          slots: {
            customRender: 'tipoAgendamento',
          },
        },
        {
          title: 'Profissional',
          dataIndex: 'nomeProfissional',
          key: 'nomeProfissional',
          slots: {
            customRender: 'nomeProfissional',
          },
        },
        {
          title: 'Categoria do Atendimento',
          dataIndex: 'categoriaAtendimento',
          key: 'categoriaAtendimento',
          slots: {
            customRender: 'categoriaAtendimento',
          },
        },
        {
          title: 'Unidade',
          dataIndex: 'unidadeAtendimento',
          key: 'unidadeAtendimento',
          slots: {
            customRender: 'unidadeAtendimento',
          },
        },
        {
          title: 'Situação',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: {
            customRender: 'situacao',
          },
        },
        {
          title: 'Registar Atendimento',
          slots: {
            customRender: 'registrarAtendimento',
          },
        },
      ],
    };
  },
  async created() {
    await this.getUnidade();
    this.pesquisar(true);
  },
  methods: {
    async handleSearchPaciente(value) {
      value.length >= 3
        ? await getPaciente({
            nome: value,
          }).then((r) => {
            this.pacientesSearch = r.data.pacientes;
          })
        : (this.pacientesSearch = []);
    },
    async handleSearchPacienteCpf(value) {
      value.length === 14
        ? await getPaciente({
            cpf: value.replace('-', '').replaceAll('.', ''),
          }).then((r) => {
            this.pacientesCpfSearch = r.data.pacientes;
          })
        : (this.pacientesCpfSearch = []);
    },
    onSelectPac(pac) {
      this.formConsult.idPaciente = pac.id;
      this.formConsult.nome = pac.nome;
      this.formConsult.cpf = pac.cpf;
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      if (!validarCpf(value)) this.$refs.cpf.classList.value = ['form-control is-invalid'];
    },
    async getUnidade() {
      await getUnidadeAtendimento().then((r) => {
        this.unidadeAtendimentos = r.data;
      });
    },
    async pesquisar(ignorarFiltros) {
      let formConsultRequest = {
        ...this.formConsult,
      };
      if (ignorarFiltros) {
        let dataHoje = moment().format('YYYY-MM-DD');
        formConsultRequest.dataInicio = dataHoje;
        formConsultRequest.dataFim = dataHoje;
      } else {
        formConsultRequest = {
          ...this.formConsult,
        };
      }
      formConsultRequest.idProfissional = this.idProf;
      await consultarAgendamento(formConsultRequest).then(async (r) => {
        this.todosAtendimentos = r.data;
      });
    },
    limpar() {
      this.formConsult = {
        idProfissional: null,
        unidadeAtendimento: null,
        idPaciente: null,
        cpf: null,
        dataInicio: null,
        dataFim: null,
      };
      this.pesquisar(true);
    },
    verificarCampoPesquisa() {
      let validate = true;
      if (!this.formConsult.idProfissional && !this.formConsult.unidadeAtendimento && !this.formConsult.idPaciente) {
        validate = false;
      }
      return validate;
    },
    getDtAtual() {
      const hoje = new Date();
      const dd = `${hoje.getDate()}`.padStart(2, '0');
      const mm = `${hoje.getMonth() + 1}`.padStart(2, '0');
      const aaaa = hoje.getFullYear();
      return `${aaaa}-${mm}-${dd}`;
    },
    async registrarAtendimento(agendamentoMedico) {
      if (!agendamentoMedico.possuiAtendimento) {
        await getByIdAgendamento(agendamentoMedico.id).then(async (ra) => {
          await createRegistroAtendimento({
            agendamentoMedico: ra.data,
          }).then((r) => {
            this.$router.push({
              path: '/acompanhamento-paciente',
              query: {
                id: r.data.id,
              },
            });
          });
        });
      } else {
        await getByIdAgendamentoMedico(agendamentoMedico.id).then((r) => {
          this.$router.push({
            path: '/acompanhamento-paciente',
            query: {
              id: r.data.id,
            },
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.icon-atendimento {
  margin-left: 30px;
  font-size: 25px;
  cursor: pointer;
}
</style>
